import React from 'react';
import {
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Img,
  ListItem,
  Text,
  Link,
  UnorderedList,
} from '@chakra-ui/react';
import { FaLinkedin, FaTwitter } from 'react-icons/fa';

const AntlerBlog: React.FC = () => (
  <>
    {/* members */}
    <Flex
      as="section"
      flexDirection="column"
      overflow="hidden"
      justify="center"
      height="300px"
      minH="300px"
      maxH="300px"
      pos="relative"
    >
      <Img
        pos="absolute"
        objectFit="cover"
        src="/jpg/blogBanner.jpg"
        alt="members-hero"
        height="100%"
        width="100%"
      />
      <Box
        bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
        pos="absolute"
        height="100%"
        width="100%"
        // eslint-disable-next-line no-constant-condition
        opacity="0.7"
      />
      <Container
        maxW="container.xl"
        position="relative"
        zIndex="1"
        flexDir="column"
        px={{ xs: '20px', sm: '28px', md: '45px', lg: '60px', xl: 'inherit' }}
      >
        <Heading
          as="h1"
          mb="20px"
          variant="reportCardTitle"
          fontSize={{ xs: '26px', sm: '28px', md: '32px', lg: '38px' }}
          color="white"
          lineHeight={{ xs: '32px', sm: '34px', md: '39px', lg: '42px' }}
        >
          FUND IN FOCUS: Antler Bets Big on Founders, Aims to Build NextGen
          successful companies in India
        </Heading>
        <Text
          fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
          fontWeight="600"
          color="white"
          lineHeight="21px"
        >
          Nitin Sharma, Partner, Antler
        </Text>
      </Container>
    </Flex>
    <Container
      as="section"
      maxW="container.xl"
      pb="80px"
      pt="40px"
      minH="420px"
      display={{ xs: 'flex', md: 'inherit' }}
      flexDirection="column"
    >
      <Box w="100%" pb="40px" as="main">
        <Text variant="blogAnswer">
          Welcome to our ‘Fund in Focus’ series where we profile our member
          funds, underscore their investment philosophy, and highlight some of
          their interesting work. Today we speak to Nitin Sharma who joined
          Antler two years ago. While India possesses boundless opportunities as
          a growing economy, the gaps persist, especially at the seed and
          pre-seed stage. It is this needs gap which&nbsp;
          <Flex
            display="inline-flex"
            alignItems="center"
            _hover={{ textDecoration: 'underline' }}
            cursor="pointer"
          >
            <Text variant="blogAnswer" textDecor="underline">
              <a
                href="https://www.antler.co/location/india"
                target="_blank"
                rel="noreferrer"
              >
                &nbsp;Antler India&nbsp;
              </a>
            </Text>
          </Flex>
          &nbsp;wants to address by bringing best global practices at the idea
          stage and support impact enterprises of tomorrow.
        </Text>
      </Box>

      <Img
        src="/jpeg/nitin.jpeg"
        alt="Nitin Sharma"
        boxSize="300px"
        float={{ xs: 'right', md: 'left' }}
        alignSelf={{ xs: 'center', md: 'flex-start' }}
        mx={{ xs: '0px', md: '0px' }}
        mr={{ xs: '0px', md: '40px', lg: '70px' }}
        mb="20px"
        objectFit="cover"
      />
      <Box>
        <Flex flexDir={{ xs: 'column', lg: 'row' }} rowGap="16px">
          <Heading
            textAlign={{ xs: 'center', md: 'left' }}
            fontWeight="800"
            color="blue.400"
          >
            Spokesperson: Nitin Sharma, Partner, Antler
          </Heading>
          <Flex
            columnGap={{ xs: '4px', md: '16px' }}
            justifyContent={{ xs: 'center', md: 'flex-start' }}
            transform={{ xs: 'translateX(12px)', md: 'none' }}
          >
            <Box alignSelf="center">
              <Link
                href="https://www.linkedin.com/in/nitinsharma15/"
                target="_blank"
              >
                <IconButton
                  aria-label="linkedin"
                  icon={
                    <FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />
                  }
                  variant="unstyled"
                  cursor="pointer"
                />
              </Link>
            </Box>
            <Box alignSelf="center">
              <Link href="https://twitter.com/nitinsharma1" target="_blank">
                <IconButton
                  aria-label="twitter"
                  icon={
                    <FaTwitter size="28px" color="rgba(100, 100, 140, 0.6)" />
                  }
                  variant="unstyled"
                  cursor="pointer"
                />
              </Link>
            </Box>
          </Flex>
        </Flex>
        <Box
          ml={{ xs: 'auto', md: '345px', lg: '370px' }}
          mr={{ xs: 'auto', md: '0px' }}
          width={{ xs: '160px', md: '80px' }}
          h="2px"
          bgColor="primary.500"
          borderRadius="5px"
          mt={{ xs: '16px', md: '10px' }}
          mb="15px"
        />
        <Box>
          <Heading variant="blogQuestion" pb="20px" pt="16px" pl="-20px">
            1. What is the investment strategy of Antler for a diverse market
            like India?
          </Heading>
          <Text variant="blogAnswer" pb="20px">
            As India’s early-stage ecosystem matures, it’s time for an
            institutional platform at the pre-seed stage to help founders build
            global-ready unicorns. That’s where Antler India comes in.
          </Text>
          <Text variant="blogAnswer" pb="20px">
            Antler India fills two critical gaps in the expanding Indian startup
            ecosystem. Firstly, it is a rare global institutional fund focused
            on the pre-seed stage in India, with proprietary platforms designed
            to support founders at the earliest stages (even pre-idea). We
            believe the maximum opportunity for impact and investment alpha is
            in creating new companies, not just chasing deals.
          </Text>
          <Text variant="blogAnswer" pb="20px">
            Secondly, it particularly serves founders “building in India, for
            the world”, which we believe is a big trend that will play out.
            Globally, Antler is the world’s fastest-growing early-stage
            platform, with a founding team consisting of operators and early
            investors in companies like Spotify, Grab, Tokopedia, Lazard’s and
            Zalora. The India fund is being built by an operator-investor
            combination of Rajiv Srivatsa (co-founder, Urban Ladder) and Nitin
            Sharma (India & US VC for 10+ years). Besides the two GPs, most of
            our India team leaders have also been founders themselves.
          </Text>
          <Text variant="blogAnswer" pb="20px">
            As day zero investors, we are in the business of facilitating
            company creation from ground zero over chasing deal flows, which in
            essence sets us apart and helps us reach out to a broad base of both
            aspiring and early-stage founders. We have 3 distinct offerings for
            the early-stage founder:
          </Text>
          <ol type="a" style={{ paddingLeft: '30px' }}>
            <li style={{ paddingBottom: '14px' }}>
              <Text variant="blogAnswer">
                Antler India Residency (AIR) Program for the pre-team founder
              </Text>
            </li>
            <li style={{ paddingBottom: '14px' }}>
              <Text variant="blogAnswer">
                Antler India Pre-Seed Platform for the founder with a ready team
              </Text>
            </li>
            <li style={{ paddingBottom: '14px' }}>
              <Text variant="blogAnswer">
                The Antler India Fellowship (AIF) for the college founder
              </Text>
            </li>
          </ol>
          <Text variant="blogAnswer" pb="20px">
            Across these programs, we take contrarian bets in new areas of
            innovation like climate tech, web 3.0, mental health, AI, vertical
            SaaS and others. The goal is to incubate ideas across domains and
            take true venture capital bets on Indian founders and back them with
            the might of the world&apos;s largest decentralized VC firm with a
            global presence across 25 cities and 600+ startups.
          </Text>
        </Box>
        {/* Question 2 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            2. In India, there is a distinct funding gap at pre-seed and seed
            levels. Angel investors and micro-VCs are deeply involved in
            early-stage investing. As Antler India is an early-stage investor,
            what is your method in identifying noteworthy ideas and businesses?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              Antler is the world’s largest pre-seed platform with a presence in
              India. This gives us a unique insight into the minds of
              early-stage founders across the world and then apply them to
              India. We saw 25,000+ founders apply to us over the first 20
              months of operations in India, making us the largest pre-seed
              funnel in the country. This continues to give us a unique window
              into emerging technology trends and insights into various sectors.
              The applications are processed by an in-house team that leverages
              subject matter expertise to help source potential founders.
            </Text>
            <Text variant="blogAnswer" pb="16px">
              Parallelly, we have a unique platform in the form of Antler India
              Residency, where we work closely with founders over a period of
              4-5 months and help them get from idea to team to funding. When
              you are investing in the early stages, it&apos;s hard to get a
              good understanding of the people unless you spend quality time
              with them. That&apos;s where a lot of the magic happens. Because
              spotless integrity, big ambition, and solid work ethic really
              shine through over a period of several months versus in a couple
              of pitch meetings. At Antler, we get to know all our founders as
              people, colleagues, and friends—which makes us very comfortable
              backing them.
            </Text>
            <Text variant="blogAnswer" pb="16px">
              Recently we have also started to partner with colleges in India
              for the Antler India Fellowship. From the inaugural program in
              which students from over 700 colleges participated, we have funded
              3 startups. Our method stands out from any other
              pre-seed/early-stage investor in India both in terms of the
              overall breadth of reach and depth of the selection process.
            </Text>
            <Text variant="blogAnswer" pb="16px">
              In addition, we are obsessed with futuristic themes where we
              believe giant global companies will be built from India, and where
              we have significant investing or operating experience. We take a
              very long view and do not mind being ahead of the curve.
            </Text>
          </Box>
        </Box>

        {/* Question 3 */}
        <Box>
          <Img
            mt="20px"
            src="/jpg/antlerInfographic.jpg"
            alt="answer-list"
            w={{ md: '440px', lg: '500px' }}
            h="auto"
            float={{ xs: 'none', md: 'right' }}
            mx={{ xs: 'auto', md: '0px' }}
            ml={{ xs: '0px', md: '32px', lg: '45px' }}
            mb="20px"
            objectFit="contain"
            display={{ xs: 'none', md: 'block' }}
          />
          <Flex w="100%" justify="center" display={{ xs: 'flex', md: 'none' }}>
            <Img
              mt="20px"
              src="/jpg/antlerInfographic.jpg"
              w={{ xs: '90%', sm: '90%' }}
              h="auto"
              alt="answer-list"
              mr={{ xs: '0px', md: '55px' }}
              mb="20px"
              objectFit="contain"
            />
          </Flex>
          <Box py="16px">
            <Heading variant="blogQuestion" pt="28px">
              3. What&apos;s your take on the Indian emerging tech space with
              Metaverse, Web3, Crypto, climate-tech etc.? How, according to you,
              is frontier technology poised to disrupt enterprise tech space?
            </Heading>
            {/* 1st set of list */}
            <Box pt="16px">
              <Text variant="blogAnswer" pb="8px">
                We are extremely positive and bullish on India’s emerging tech
                space in areas like metaverse, Web3, crypto, and climate tech.
                We have made investments in each of them, with Juno Finance,
                Flint, PYOR and 5 others in Web3, Invact in metaverse, and
                Sangti in climate tech.
              </Text>
              <Text variant="blogAnswer" pb="8px">
                Indian teams in these spaces will build for the world from
                India. Indian founders, engineering and marketing talent are
                uniquely positioned to take advantage of the overall trend of
                Indian firms moving from offering cost-effective services to
                building world-class products and platforms.
              </Text>
              <Text variant="blogAnswer" pb="8px">
                Add to this Antler’s global presence that allows our startups to
                leverage offices and resources across the world to test,
                validate, and scale global products.
              </Text>
              <Text variant="blogAnswer" pb="8px">
                Frontier technology like AI and others can be enablers or death
                knells for enterprises that don’t adopt them. Startups that help
                build solutions for enterprises to adopt new technology
                paradigms like AI stand to gain a lot from this evolution. This
                is why we have backed startups like Hexo AI, which are at the
                intersection of cutting-edge tech, enterprise know-how, and
                Indian founders with a global mindset.
              </Text>
            </Box>
          </Box>
        </Box>
        {/* Question 4 */}
        <Box py="16px">
          <Heading variant="blogQuestion" pt="16px">
            4. What is the philosophy of Antler being a people-centric
            investment firm?
          </Heading>
          <Box>
            <Text variant="blogAnswer" py="16px">
              Being a founder-first VC firm, Antler is deeply invested in the
              individual. At these early stages, where there is little else to
              go by, we are in the business of taking founder bets and enabling
              new team formation. We strongly believe that enabling early-stage
              founders and providing them with the right conditions to succeed
              will be the key to building the next generation of successful
              companies. We believe that in order to make progress inevitable,
              it has to start with the people.
            </Text>
          </Box>
        </Box>

        {/* Question 5 */}
        <Box pt="8" pb="20px">
          <Heading variant="blogQuestion" pb="20px" pt="12px">
            5. What are your thoughts on the &apos;India Opportunity&apos;
            today? Which are the most important growth drivers for the economy
            in the next two decades?
          </Heading>

          <Text variant="blogAnswer" pt="8px">
            We are excited about 4 major themes that will define the &quot;India
            Opportunity&quot; for us. Many of these call for bold, more global
            thinking from Day 1.
          </Text>

          <UnorderedList pt="16px">
            <ListItem>
              <Heading variant="blogQuestion">
                Building on the world&apos;s best Digital Public Goods (DPG)
              </Heading>
              <Text variant="blogAnswer" pb="8px">
                India&apos;s putting together the world&apos;s most widely
                adopted DPGs that commoditize key aspects of commerce, payments,
                and lending with UPI, OECN, ONDC, India Stack and Aadhaar. These
                DPGs will be powerful catalysts driving economic growth going
                forward.
              </Text>
            </ListItem>
            <ListItem>
              <Heading variant="blogQuestion">
                The rise of new global SaaS
              </Heading>
              <Text variant="blogAnswer" pb="8px">
                Companies like Browserstack, Innovaccer, Postman and SignEasy
                have emerged as category leaders by &apos;building in India for
                the globe&apos;. This trend will accelerate due to a maturing
                SaaS ecosystem and the emergence of the &apos;building in India
                for the globe&apos; playbook.
              </Text>
            </ListItem>

            <ListItem>
              <Heading variant="blogQuestion">Climate change solutions</Heading>
              <Text variant="blogAnswer" pb="8px">
                India is the world’s largest fast-growing economy, and the rate
                of per capita energy consumption will only increase. This opens
                opportunities for climate tech and sustainability startups to
                enable every individual, organization and enterprise to become
                carbon-neutral and efficient over the next few decades.
              </Text>
            </ListItem>

            <ListItem>
              <Heading variant="blogQuestion">
                Building global Web 3.0 infrastructure
              </Heading>
              <Text variant="blogAnswer" pb="8px">
                India is moving from services to products to platforms esp. in
                areas like Web3. Founders are rapidly acquiring skills and
                thinking big to create global platforms/ecosystems and
                communities. With projects like Polygon being built in India for
                the world&apos;s blockchain developers to build on, India will
                be one of the world&apos;s best builders of Web 3.0
                infrastructure.
              </Text>
            </ListItem>
          </UnorderedList>
        </Box>

        {/* Questions 6 */}
        <Box pt="8" pb="20px">
          <Heading variant="blogQuestion" pb="20px" pt="12px">
            6. Any advice to budding entrepreneurs?
          </Heading>

          <Text variant="blogAnswer" pt="8px">
            Given the current economic climate, we feel this is one of the best
            times for exceptional would-be founders to take the entrepreneurial
            leap if they are truly driven by a problem or mission.
          </Text>

          <Text variant="blogAnswer" pt="8px">
            Founders who start now have the advantage of building product and
            customer-first ventures with fewer distractions and rivals who have
            inferior products but superior marketing budgets.
          </Text>

          <Text variant="blogAnswer" pt="8px">
            1 out of 3 Fortune 500 companies started in a recession and that is
            because constraints also enable creativity and grit. So, our advice
            would be that if you are a budding entrepreneur, take the leap and
            give us a call!
          </Text>
        </Box>
      </Box>
      <Heading
        variant="blogQuestion"
        lineHeight="30px"
        pt="16px"
        fontStyle="italic"
      >
        The content in this section is curated by Team IVCA. For any feedback,
        connect with&nbsp;
        <Link
          href="mailto:paromita.sinha@ivca.in"
          style={{ color: 'blue', textDecoration: 'underline' }}
        >
          paromita.sinha@ivca.in
        </Link>
      </Heading>
    </Container>
  </>
);

export default AntlerBlog;
